import { StrapiUser } from '../core/models/strapi-user.model';
import { StrapiVendor } from '../core/models/strapi-vendor.model';

const getFirstVendor = (user: StrapiUser | null): StrapiVendor | null => {
  if (user?.vendors && user.vendors.length > 0) {
    return user.vendors[0];
  }

  return null;
};

export { getFirstVendor };
